/* 陸遜傳・第 2 章：宜都（219 年）
 * 長江在南邊由西往東。東邊是宜都郡城，陸遜從東邊（南郡）來；四位長吏、蠻夷君長散在郡城以西的山裡與江邊。
 * 中間是峽口：南北兩片山岩夾著一條道，詹晏、陳鳳守在這裡。再往西是秭歸，文布、鄧凱的夷兵在那裡。 */
export const START = [8600, 2500], CITY = [7400, 2200], PASS = [4300, 2250], ZIGUI = [1500, 2050], YI = [900, 1500];
export const CHIEFS = [[6500, 1050], [5700, 3250], [5000, 1250], [7900, 3300]], CHIEF_NAMES = ['巫縣長吏', '夷道長吏', '蠻夷君長', '江邊君長'];
export default {
  id: 'luxun_yidu', name: '宜都', W: 9000, H: 4600, seed: 219,
  bases: [START, YI],
  rivers: [{ pts: [[-100, 3950], [3000, 3900], [6000, 3980], [9100, 3920]], hw: 320, fords: [] }],
  roads: [
    { pts: [START, CITY, [5800, 2200], PASS, [2700, 2200], ZIGUI, YI], w: 140 },
    { pts: [[5800, 2200], [6500, 1050]], w: 100 },
    { pts: [[5800, 2200], [5700, 3250]], w: 100 },
    { pts: [[5800, 2200], [5000, 1250]], w: 100 },
    { pts: [CITY, [7900, 3300]], w: 100 },
  ],
  rocks: [[4300, 1150, 320, 700], [4300, 3250, 320, 520], [2400, 900, 400, 200], [7600, 900, 400, 200]],
  woods: 0.55,
  sight: 0.8,
  clearings: [[CITY[0], CITY[1], 520], [START[0], START[1], 400], [PASS[0], PASS[1], 260], [ZIGUI[0], ZIGUI[1], 420], [YI[0], YI[1], 380], ...CHIEFS.map(([x, y]) => [x, y, 260])],
  villages: [{ x: CITY[0], y: CITY[1] - 80, n: 8, r: 420 }, { x: ZIGUI[0], y: ZIGUI[1], n: 5, r: 320 }, ...CHIEFS.map(([x, y]) => ({ x: x + 60, y: y - 150, n: 2, r: 180 }))],
  tents: [{ x: YI[0], y: YI[1], n: 6, r: 340, chief: true, col: '#7a4a3a', flag: '文' }, { x: PASS[0] - 500, y: PASS[1], n: 4, r: 260, col: '#3e7b50', flag: '漢' }],
};
